import { NextApiResponseBody } from 'types/bolt-api/request'
import { ItsmeUserInfoResponseBody } from 'lib/itsme/types'
import { Language } from 'types/language'
import { stringify } from 'qs'

/**
  POST requests to exchange the authorization code for an access token
  @param {string} code - The authorization code received from the itsme authorization process
  @param {Language} language - To determine the correct redirect_uri
  @returns The response body containing the access token or undefined in case of an error
 */
const getTokenAndUserInfo = async (
  code: string,
  language: Language
): Promise<NextApiResponseBody<ItsmeUserInfoResponseBody | undefined>> => {
  try {
    const query = stringify({ code, language })
    const userInfoResponse = await fetch(`/api/itsme/user-info?${query}`, {
      method: 'GET'
    })

    const userInfo: NextApiResponseBody<ItsmeUserInfoResponseBody | undefined> = await userInfoResponse.json()

    if (!userInfo.success) {
      return {
        success: false,
        message: userInfo.message || 'Failed to get user info'
      }
    }

    return {
      success: true,
      data: userInfo.data
    }
  } catch (error) {
    console.error('Error in itsmeGetTokenAndUserInfo:', error)
    return {
      success: false,
      message: error.message
    }
  }
}

export default getTokenAndUserInfo
